module.exports = __webpack_public_path__ + "img/yuyan.561711ca.png";